import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { getUpcomingLoanPayments } from 'selectors/getUpcomingLoanPayments';
import { getApplicationData } from 'selectors/getApplicationData';
import { getUpcomingLoanPayments as getUpcomingLoanPaymentsThunk } from 'thunks';
import { formatTextDate, formatYearMonthDayToDate } from 'utils/dateUtils';
import { FlowComponentType } from 'routes/types';
import PaymentDetail, { PaymentDetailRow } from 'components/FinancialCheckup/PaymentDetail';

const LoanPaymentDetail = (props: FlowComponentType) => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { payments, isLoading } = useSelector(getUpcomingLoanPayments);
  const applicationData = useSelector(getApplicationData);
  const applicationId = applicationData.application?.id;

  const payment = payments.find((p) => p.id.toString() === id);

  useEffect(() => {
    if (!payment && applicationId) {
      dispatch(getUpcomingLoanPaymentsThunk(applicationId));
    }
  }, [payment, applicationId, dispatch]);

  const getPaymentDetailData = () => {
    if (!payment) {
      return null;
    }

    const { chargeAmount, date: dateString, period } = payment;

    const scheduledDate = dateString ? formatYearMonthDayToDate(dateString) : null;

    const detailRows: PaymentDetailRow[] = [
      { title: 'Type', value: 'Scheduled Loan Payment' },
      { title: 'Period', value: `Period #${period}` },
      { title: 'Date', value: scheduledDate ? formatTextDate(scheduledDate) : 'Not available' },
    ];

    return {
      amount: chargeAmount,
      detailRows,
    };
  };

  const paymentData = getPaymentDetailData();

  return (
    <PaymentDetail
      {...props}
      amount={paymentData?.amount ?? 0}
      detailRows={paymentData?.detailRows ?? []}
      isLoading={isLoading && !payment}
      error={!isLoading && !payment ? 'Payment not found' : undefined}
    />
  );
};

export default LoanPaymentDetail;
